import { Flex } from '@chakra-ui/react'
import { ContentNode, FieldContentNode } from '@helo/cms'
import { Deferred, pipe } from '@helo/utils'

import { Icon } from '../../../components/Icons/Icon'
import { Link } from '../../../components/Link/Link'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { TypeRenderer } from '../../../datatypes/TypeRenderer'
import { CellRendererProps } from '../table.types'

export const TypeRendererCell = ({
  // value,
  contentNode,
  // colDef,
  isCellHover = true,
}: CellRendererProps<string | number | null> & {
  contentNode: FieldContentNode
  isCellHover?: boolean
}) => {
  const state = contentNode.state ?? {}
  const ofType = contentNode.ofType as ContentNode | undefined
  const mergedContentNode = ofType
    ? {
        ...ofType,
        state: pipe(
          ofType.state ?? {},
          Deferred.merge(contentNode.state ?? {}),
        ),
      }
    : undefined
  // const defaultOptions: TextDataType['options'] = {
  //   size: 'small',
  // }
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <TypeRenderer
        // value={value as any}
        contentNode={(mergedContentNode ?? contentNode.ofType) as ContentNode}
        // options={{ ...defaultOptions, ...colDef.options }}
        // context={colDef.context}
      />
      {state?.linkUrl && !state?.linkDisableTabIcon && isCellHover && (
        <Link
          to={state?.linkUrl}
          search={state?.linkUrlStorage}
          target="_blank"
        >
          <Tooltip label="Open Link in New Tab" placement="top">
            <Icon
              icon="ExternalLinkIcon"
              color="presets.turquoise.60"
              boxSize="16px"
              marginTop="-4px"
            />
          </Tooltip>
        </Link>
      )}
    </Flex>
  )
}
